export const supplierCatalogDefaultValues = {};
